export default {
	setPersonWithAudit(state, value) {
		state.personWithAudit = value;
	},
	setAudits(state, value) {
		state.audits = value;
	},
	setLoading(state) {
		state.loading = !state.loading;
	},
	setOneAudits(state, value) {
		if (value) state.oneAudit = value;
		else state.oneAudit = null;
	},
};
